export default __webpack_public_path__ + "static/media/TNS-Web-Banners.fdf6371c.png";